export class Events
{
    public static ERROR_MESSAGING: string = "ERROR_MESSAGING";
    public static APP_MESSAGE: string = "APP_MESSAGE";
}
